import { useState } from "react";
import { ICONS } from "../art";
import { useStore } from "../state/store";
import { Avatar } from "./Avatar";
import { Icon } from "./Icon";
import styles from "./Spectators.module.css";

/** Eye button in the table pane's corner listing who is watching. */
export function Spectators() {
  const lobby = useStore((s) => s.lobby)!;
  const you = useStore((s) => s.you);
  const send = useStore((s) => s.send);
  const watchers = lobby.spectators;
  const spectating = watchers.some((s) => s.id === you);
  // Spectators see the list straight away.
  const [open, setOpen] = useState(spectating);
  const isHost = lobby.hostId === you;

  return (
    <div className={styles.wrap}>
      <button
        type="button"
        className={`${styles.toggle} ${open ? styles.open : ""}`}
        aria-label={`Spectators: ${watchers.length}`}
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <Icon path={ICONS.eye} size={20} />
        {watchers.length}
        {spectating && <span className={styles.you}>Spectating</span>}
      </button>
      {open && (
        <div className={styles.panel}>
          <div className={styles.heading}>Spectators</div>
          {watchers.length ? (
            <div className={styles.list}>
              {watchers.map((s) => (
                <div key={s.id} className={styles.row} style={{ opacity: s.connected ? 1 : 0.5 }}>
                  <Avatar avatar={s.avatar} size={28} ring={2} />
                  <span className={styles.name}>{s.name}</span>
                  {s.id === you ? (
                    <span className={styles.tag}>{isHost ? "You · host" : "You"}</span>
                  ) : isHost ? (
                    <button
                      type="button"
                      className={styles.kick}
                      aria-label={`Kick ${s.name}`}
                      onClick={() => send({ t: "host", op: { op: "kick", playerId: s.id } })}
                    >
                      Kick
                    </button>
                  ) : (
                    !s.connected && <span className={styles.tag}>Away</span>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.empty}>No one is watching.</div>
          )}
        </div>
      )}
    </div>
  );
}
